// extracted by mini-css-extract-plugin
export default {"modal-content-header":"appHeaderNotificationBar_modal-content-header__-eLwV","momo-modal-content":"appHeaderNotificationBar_momo-modal-content__jkBwU"};